import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
	addConfigsData,
	getConfigsData,
	editConfigsData,
	deleteConfigsData,
} from '../../../services/services';
import { toast } from 'sonner';

export const getAllConfigs = createAsyncThunk('listConfigs', async (_, thunkAPI) => {
	try {
		const response = await getConfigsData();
		if (!response?.data?.success) {
			return thunkAPI.rejectWithValue(response?.data?.message);
		}
		return response?.data;
	} catch (error) {
		return thunkAPI.rejectWithValue(error);
	}
});

export const addConfigurationData = createAsyncThunk(
	'addConfigurations',
	async (data, thunkAPI) => {
		try {
			const response = await addConfigsData(data);
			if (!response?.data?.success) {
				return thunkAPI.rejectWithValue(response?.data?.message);
			}
			return response?.data;
		} catch (error) {
			return thunkAPI.rejectWithValue(error);
		}
	},
);

export const editConfigurationData = createAsyncThunk(
	'editConfigurations',
	async (data, thunkAPI) => {
		try {
			const response = await editConfigsData(data.id, data);
			if (!response?.data?.success) {
				return thunkAPI.rejectWithValue(response?.data?.message);
			}
			return response?.data;
		} catch (error) {
			return thunkAPI.rejectWithValue(error);
		}
	},
);

export const deleteConfigurationData = createAsyncThunk(
	'deleteConfigurations',
	async (id, thunkAPI) => {
		try {
			const response = await deleteConfigsData(id);
			if (!response?.data?.success) {
				return thunkAPI.rejectWithValue(response?.data?.message);
			}
			return { id, ...response?.data };
		} catch (error) {
			return thunkAPI.rejectWithValue(error);
		}
	},
);

const settingSlice = createSlice({
	name: 'settingSlice',
	initialState: {
		configsDetails: [],
		error: null,
		isLoading: false,
		configData: null,
	},
	extraReducers: (builder) => {
		builder
			// Get All
			.addCase(getAllConfigs.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(getAllConfigs.fulfilled, (state, action) => {
				state.isLoading = false;
				state.configsDetails = action.payload;
				state.error = null;
			})
			.addCase(getAllConfigs.rejected, (state, action) => {
				state.isLoading = false;
				state.configsDetails = [];
				state.error = action.payload;
			})

			// Add Config
			.addCase(addConfigurationData.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(addConfigurationData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.configData = action.payload;
				state.error = null;
				toast.success('Configuration added successfully!');
			})
			.addCase(addConfigurationData.rejected, (state, action) => {
				state.isLoading = false;
				state.configData = null;
				state.error = action.payload;
				toast.error(state.error);
			})

			// Edit Config
			.addCase(editConfigurationData.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(editConfigurationData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.configData = action.payload;
				state.error = null;
				toast.success('Configuration updated successfully!');
			})
			.addCase(editConfigurationData.rejected, (state, action) => {
				state.isLoading = false;
				state.configData = null;
				state.error = action.payload;
				toast.error(state.error);
			})

			// Delete Config
			.addCase(deleteConfigurationData.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(deleteConfigurationData.fulfilled, (state, action) => {
				state.isLoading = false;
				state.error = null;

				if (Array.isArray(state.configsDetails)) {
					state.configsDetails = state.configsDetails.filter(
						(item) => item.id !== action.payload.id,
					);
				}
				toast.success('Configuration deleted successfully!');
			})
			.addCase(deleteConfigurationData.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload;
				toast.error(state.error);
			});
	},
});

export default settingSlice.reducer;
